// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ikD2","index":"styles_index__3r2JL"};